import homePageStyles from "../../modules/home/home-page.module.scss";
import TabGroup from "../../modules/home/v2/tabs/TabGroup";

function CategoryMakesModel(props: any) {
  const { heading = "Featured Models", data } = props;
  return (
    <div id="popular-models" className={`section ${homePageStyles.StyledFeaturedMake}`}>

      <div className="heading">{heading}</div>

      <TabGroup data={data} />
    </div>
  );
}

export default CategoryMakesModel;
